import React from "react";
import * as AppActions from "../redux/actions/app.actions";
import styled from "styled-components";
import { useMutation } from "@apollo/react-hooks";
import StripeButton from "../assets/images/stripe-button.png";
import { useQuery } from "@apollo/client";
import url from "url";
import GET_PROFILE from "@sellout/models/.dist/graphql/queries/profile.query";
import CONNECT_STRIPE from "@sellout/models/.dist/graphql/mutations/connectStripe.mutation";
import { getErrorMessage } from "@sellout/ui/build/utils/ErrorUtil";
import { Flex, Loader, LoaderSizes, Colors } from "@sellout/ui";
import UPDATE_ORG_WEBHOOK_EMAIL from "@sellout/models/.dist/graphql/mutations/updateOrgEmailWebhook.mutation";
import { AppNotificationTypeEnum } from "../models/interfaces/IAppNotification";
import { useDispatch } from "react-redux";


const ButtonImg = styled.img`
  cursor: pointer;
  width: 185px;
  height: auto;
`;

export const Spacer = styled.div`
  width: 15px;
`;

export enum StripeConnectEnum {
  BaseLink = "https://connect.stripe.com/oauth/authorize",
  ClientId = "?client_id=",
  RedirectUrl = "&redirect_uri=",
  ResponseType = "&response_type=code",
  Scopes = "&scope=read_write",
}

type ConnectStripeButtonProps = {
  stripeClientId?: string;
  stripeRedirectUrl?: string;
  stripeId?: string;
  setErrorMsg: Function;
};

const ConnectStripeButton: React.FC<ConnectStripeButtonProps> = ({
  stripeClientId,
  stripeRedirectUrl,
  stripeId,
  setErrorMsg,
}) => {

  const dispatch = useDispatch();
  const { data: profileEmail } = useQuery(GET_PROFILE);
  const parsed = url.parse(window.location.toString(), true);
  const connectCode = parsed.query.code;

  const [updateOrgEmail] = useMutation(
    UPDATE_ORG_WEBHOOK_EMAIL,
    {
      onError(error) {
        setErrorMsg(error?.message);
        dispatch(
          AppActions.showNotification(
            error.message,
            AppNotificationTypeEnum.Error
          )
        );
      },
    }
  );

  const [connectStripe, { loading, called }] = useMutation(CONNECT_STRIPE, {
    refetchQueries: [{ query: GET_PROFILE }],
    awaitRefetchQueries: true,
    onCompleted(data) {
      if (data?.connectStripe) {
        updateOrgEmail({
          variables: {
            email:profileEmail?.organization?.email|| "",
          },
        });
      }
    },
    onError(error) {
      setErrorMsg(getErrorMessage(error));
    },
  });
  if (connectCode && !loading && !stripeId && !called) {
    connectStripe({
      variables: {
        connectCode,
      },
    });
  }
  const baseLink = StripeConnectEnum.BaseLink;
  const clientId = `${StripeConnectEnum.ClientId}${stripeClientId}`;
  const redirectUrl = `${StripeConnectEnum.RedirectUrl}${stripeRedirectUrl}`;
  const responseType = StripeConnectEnum.ResponseType;
  const scopes = StripeConnectEnum.Scopes;
  const connectLink = baseLink + clientId + redirectUrl + responseType + scopes;

  return (
    <Flex align="center">
      <ButtonImg
        onClick={() => (loading ? null : window.location.replace(connectLink))}
        src={StripeButton}
      />
      {loading && (
        <>
          <Spacer />
          <Loader size={LoaderSizes.Small} color={Colors.Orange} />
        </>
      )}
    </Flex>
  );
};

export default ConnectStripeButton;
